module.exports = __webpack_public_path__ + "static/media/vv2022.2521620d.png";